import { __awaiter } from '../external_node_modules/tslib/tslib.es6.js';
import { ENTITY_TYPES } from '../constants/entityType.js';
import { PURCHASE_STATUSES } from '../constants/purchaseStatuses.js';
import { RESTRICTION_STATUTES } from '../constants/restrictionStatus.js';

function checkRestrictionUserAge(product, events, user) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve) => __awaiter(this, void 0, void 0, function* () {
            function isContainsLootbox() {
                var _a;
                return (_a = product.entitlements) === null || _a === void 0 ? void 0 : _a.some((entity) => {
                    return entity.type === ENTITY_TYPES.lootbox;
                });
            }
            if (!isContainsLootbox()) {
                return resolve(RESTRICTION_STATUTES.SUCCESS);
            }
            const { default: createLootboxRestriction } = yield import('../ui/LootboxRestriction/index.js');
            const lootboxRestrictionResult = yield createLootboxRestriction(product, events, user);
            if (lootboxRestrictionResult === RESTRICTION_STATUTES.CANCELLED) {
                return resolve(PURCHASE_STATUSES.CANCELLED);
            }
            return resolve(RESTRICTION_STATUTES.SUCCESS);
        }));
    });
}

export { checkRestrictionUserAge as default };
//# sourceMappingURL=userAgeRestriction.js.map
